import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toastError } from "../../../utils/toast";

interface RegistrationFormProps {
  loginPage: string;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>, formDdata: any) => void;
}

function checkPassword(s: string) {
  let number = false, upper = false, special = false;
  for (const c of s) {
    if (/\d/.test(c))            number  = true;
    else if (/[A-Z]/.test(c))    upper   = true;
    else if (/[^a-zA-Z0-9]/.test(c)) special = true;
  }
  return { length: s.length >= 7, number, upper, special };
}

function RegistrationForm({ loginPage, handleSubmit }: RegistrationFormProps) {
  const [formDdata, setFormDdata] = useState({
    email:           "",
    displayName:     "",
    contactNumber:   "",
    password:        "",
    confirmPassword: "",
  });

  function handleChange(e: React.ChangeEvent<HTMLInputElement>, field: string) {
    setFormDdata((prev) => ({ ...prev, [field]: e.target.value }));
  }

  function onFormSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const checks = checkPassword(formDdata.password);
    if (!checks.length || !checks.number || !checks.upper || !checks.special) {
      toastError("Password must be 7+ characters with an uppercase, a number and a special character");
      return;
    }
    if (formDdata.password !== formDdata.confirmPassword) {
      toastError("Passwords do not match");
      return;
    }
    handleSubmit(e, formDdata);
  }

  const checks = checkPassword(formDdata.password);
  const showChecks = formDdata.password.length > 0;
  const passwordsMatch = formDdata.confirmPassword.length > 0 && formDdata.password === formDdata.confirmPassword;
  const passwordsMismatch = formDdata.confirmPassword.length > 0 && formDdata.password !== formDdata.confirmPassword;

  const req = (met: boolean, label: string) => (
    <span style={{ display: "flex", alignItems: "center", gap: "0.3rem", color: met ? "#22c55e" : "#94a3b8" }}>
      <span style={{ fontSize: "0.75rem" }}>{met ? "✓" : "○"}</span>
      {label}
    </span>
  );

  return (
    <form onSubmit={onFormSubmit}>

      <div className="form-floating mb-3">
        <input
          type="email"
          className="form-control"
          id="reg-email"
          placeholder="name@example.com"
          value={formDdata.email}
          onChange={(e) => handleChange(e, "email")}
          required
        />
        <label htmlFor="reg-email">Email address</label>
      </div>

      <div className="row g-3 mb-3">
        <div className="col-sm-12 col-md-6">
          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="reg-name"
              placeholder="Display Name"
              value={formDdata.displayName}
              onChange={(e) => handleChange(e, "displayName")}
              required
            />
            <label htmlFor="reg-name">Display Name</label>
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="reg-contact"
              placeholder="Contact Number"
              value={formDdata.contactNumber}
              onChange={(e) => handleChange(e, "contactNumber")}
            />
            <label htmlFor="reg-contact">Contact Number</label>
          </div>
        </div>
      </div>

      <div className="form-floating mb-1">
        <input
          type="password"
          className="form-control"
          id="reg-password"
          placeholder="Password"
          value={formDdata.password}
          onChange={(e) => handleChange(e, "password")}
          required
        />
        <label htmlFor="reg-password">Password</label>
      </div>

      {/* Live password requirements */}
      {showChecks && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.2rem 0.75rem", fontSize: "0.775rem", padding: "0.6rem 0.25rem 0.5rem", marginBottom: "0.75rem" }}>
          {req(checks.length,  "7+ characters")}
          {req(checks.upper,   "Uppercase letter")}
          {req(checks.number,  "Number")}
          {req(checks.special, "Special character")}
        </div>
      )}

      <div className={`form-floating mb-1 ${!showChecks ? "mt-3" : ""}`}>
        <input
          type="password"
          className={`form-control ${passwordsMatch ? "is-valid" : ""} ${passwordsMismatch ? "is-invalid" : ""}`}
          id="reg-confirm"
          placeholder="Confirm Password"
          value={formDdata.confirmPassword}
          onChange={(e) => handleChange(e, "confirmPassword")}
          required
        />
        <label htmlFor="reg-confirm">Confirm Password</label>
        {passwordsMismatch && (
          <div className="invalid-feedback">Passwords do not match</div>
        )}
      </div>

      <button type="submit" className="btn btn-danger w-100 fw-bold py-2 mt-4">
        Register
      </button>

      <p className="text-center mt-3 mb-0" style={{ fontSize: "0.875rem", color: "#64748b" }}>
        Already a member?{" "}
        <Link to={loginPage} style={{ color: "#ed1b24", fontWeight: 600, textDecoration: "none" }}>
          Log In
        </Link>
      </p>

    </form>
  );
}

export default RegistrationForm;
